import React, { Component } from 'react';
import { Fragment } from 'react';
import {DataRPC, MedicineClass, ImageText} from '../../rpc-client/DataRPC';
import ReactHtmlParser from "react-html-parser";
import './DetailPage.css';

class MedicineDetails extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            news: [],
            medicine_order_name: "",
            medicine_order_button: "",

            name: "",
            address: "",
            phone: "",
            quantity: "",
            med_id: ""
        }
    }

    async componentDidMount() {
        // Get Medicine
        let id = this.props.match.params.id;
        this.setState({
            med_id: id
       });
        new DataRPC().fetchData('GetMedicine', {
            type: 1,
            id: id
        }, MedicineClass).then(gData => { 
            
            if (gData) {
               this.setState({
                    news: gData
               });
               console.log(this.state.news);
            }
        });

        // ---------------------------

        new DataRPC().fetchData('GetImageText', {
            page: "medicine_order"
        }, ImageText).then(gData => { 
            if (gData) {
                this.setState({medicine_order_name: gData.find(x => x.komoku === "medicine_order_name").content});
                this.setState({medicine_order_button: gData.find(x => x.komoku === "medicine_order_button").content});
            }
        });
    }

    handleSubmit = async (e) => {
        e.preventDefault();

        if (
            !this.state.name ||
            !this.state.address ||
            !this.state.quantity ||
            !this.state.phone) {
            alert('Bạn chưa điền đầy đủ thông tin đặt hàng');
            return;
        }

        if (window.confirm("Xác nhận đặt thuốc ?")) {
            new DataRPC().fetchRawData('MedicineOrder', {
                phone: this.state.phone,
                address: this.state.address,
                quantity: this.state.quantity,
                name: this.state.name,
                med_id: this.state.med_id,
            }).then(gData => { 
                if (gData) {
                    console.log(gData);
                    alert('Đặt thuốc thành công, chúng tôi sẽ liên lạc với bạn trong thời gian sớm nhất');
                    this.setState({
                        name: "",
                        address: "",
                        phone: "",
                        quantity: ""
                    })
                }
                else {
                    alert('Có lỗi xảy ra, xin thử lại sau');
                }
            });
        }
    }

    onChange = (e) => {
        this.setState({[e.target.name]:e.target.value});
    } 

    render() {
        return( 
            <Fragment>
                <section className="hc-detail-hero">
                    <div className="hc-container">
                        <div className="hc-detail-hero-inner">
                            <span>{this.state.news.description}</span>
                            <h1>{this.state.news.name}</h1>
                        </div>
                    </div>
                </section>

                <section className="hc-detail-body">
                    <div className="hc-container">
                        <div className="hc-detail-card">
                            <img src={this.state.news.ava} alt=""/>

                            <div className="hc-detail-content">
                                <h2>{this.state.news.name}</h2>
                                <div className="hc-divider" style={{margin: '10px 0 20px'}}></div>

                                <div className="hc-detail-prose">
                                    {ReactHtmlParser(this.state.news.content)}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </Fragment>
        )
    }
}

export default MedicineDetails;